import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import LinearProgress from '@mui/material/LinearProgress';
import IconButton from '@mui/material/IconButton';
import { Step, StepIcon, StepLabel, Stepper } from '@mui/material';

import Menu from '../menu/Menu';
import AlxButton from '../alx-components/button';
import SVGIcon from '../../assets/iconsComponent/svg-icon';
import { icons } from '../../assets/icons/icons';
import { NavbarStyle } from './navbar-style';

interface INavbar {
  steps?: { step: number; totalSteps: number };
  clickLeft?: () => void;
  clickRight?: () => void;
  isResume?: boolean;
  iconLeft?: string;
  iconRight?: string;
  customRight?: any;
  showMenu?: boolean;
  isService?: boolean;
  assistance?: boolean;
  showSteps?: boolean;
  stepStyle?: 'line' | 'dots';
  stepIconSize?: string;
}

const CustomStepIcon = styled(StepIcon)`
  & text {
    display: none;
  }
  &.MuiStepIcon-root.Mui-active {
    color: ${(props) => props.theme.primary.primary50};
  }
  &.MuiStepIcon-root.Mui-completed {
    color: ${(props) => props.theme.primary.primary50};
  }
`;

const Navbar: React.FC<INavbar> = ({
  steps,
  clickLeft,
  clickRight,
  iconLeft,
  isResume,
  customRight,
  showMenu,
  isService,
  assistance,
  showSteps,
  stepStyle = 'line',
  stepIconSize = '16px',
}) => {
  const { t } = useTranslation('common');

  const renderNavbarRight = () => {
    if (clickRight) {
      return (
        <div data-cy="navbar-right" className={`navbar-right`} onClick={() => clickRight()}>
          {customRight ? (
            customRight
          ) : (
            <IconButton aria-label="delete">
              <img src={icons.closeIcon} alt="" />
            </IconButton>
          )}
        </div>
      );
    }
  };

  const renderNavbarLeft = () => {
    if (clickLeft) {
      return isResume ? (
        <AlxButton className="ghost" data-cy="reset-form" onClick={() => clickLeft()}>
          {t('common:nav.reset')}
        </AlxButton>
      ) : (
        <IconButton aria-label="delete" onClick={() => clickLeft()}>
          <SVGIcon icon={iconLeft} size="24px" />
        </IconButton>
      );
    }
  };

  return (
    <NavbarStyle
      id="NavbarFixed"
      $stepIconSize={stepIconSize}
      className={classNames({
        resume: isResume,
        service: isService && !showMenu,
        'custom-right': customRight !== undefined,
      })}
      data-cy="progress-navbar"
    >
      {showMenu && clickRight && customRight ? (
        <div className="header">
          <div className="header-container">
            <Menu />
            <div onClick={() => clickRight()}>{customRight}</div>
          </div>
        </div>
      ) : (
        <div
          className={classNames('nav-container', {
            'assistance-nav': assistance,
          })}
        >
          {assistance && <Menu />}
          {(!steps || steps.step !== 0 || showSteps) && (
            <div className="navbar-wrapper">
              <div className="navbar-left">{renderNavbarLeft()}</div>
              <div className="navbar-center">
                {steps && !isResume && stepStyle === 'dots' && (
                  <Stepper activeStep={steps.step - 1}>
                    {Array.from({ length: steps.totalSteps }).map((_, i) => (
                      <Step key={i}>
                        <StepLabel slots={{ stepIcon: CustomStepIcon }}>{''}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                )}
                {steps && !isResume && stepStyle !== 'dots' && (
                  <LinearProgress variant="determinate" value={(steps.step / steps.totalSteps) * 100} />
                )}
              </div>
              {renderNavbarRight()}
            </div>
          )}
        </div>
      )}
    </NavbarStyle>
  );
};

export default Navbar;
